import { render, staticRenderFns } from "./page-one.vue?vue&type=template&id=a2f87eb8&"
import script from "./page-one.vue?vue&type=script&lang=js&"
export * from "./page-one.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports